import { css } from '@emotion/core';
// import { typography, fontWeights } from '../../../../../styles/typography';
// import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
// import { errorCss } from '../../../../ui/Form/baseStyles/index.styles';
import calendar_arrow from '../../../assets/images/calendar_arrow.png';
import { colorsPalette } from '../../../styles/colors';
import { isFirefox } from 'react-device-detect';

export const iconChevronHolder = css({
  // background: '#ff000029',
  position: 'absolute',
  width: '100%',
  height: '100%',
  right: '0',
  top: '50%',
  bottom: '0',
  display: 'flex',
  // height: '100%',
  transform: 'translateY(-50%)',
  justifyContent: 'flex-end',
  paddingRight: 15,
  i: {
    transform: 'scale(0.6)',

    // background: 'yellow',
    margin: 'auto 0',
    [MediaQueries.md]: {
      transform: 'scale(0.6)',
    },
    [MediaQueries.sm]: {
      transform: 'scale(0.6)',
    },
  },

  '.date_input': {
    input: {
      fontSize: '16px',
      color: '#616161',
    },
    label: {
      fontSize: '16px',
      color: '#616161',
    },
  },
});
export const overlay = css({
  position: 'fixed',
  backdropFilter: 'blur(5px)',
  background: isFirefox ? '#fffffff7' : '#ffffffa8',
  height: '100%',
  width: '100%',
  top: 0,
  zIndex: 3,
  left: 0,
});

export const dateHolder = css({
  '.dateinputfield': {},
  label: {},

  input: {
    color: colorsPalette.tint,
  },
});

export const dateform = css({
  '.dateinputfield': {
    marginBottom: '16px',
  },

  '.rdtPicker th': {
    height: '48px !important',
    borderBottom: 'unset',
  },

  'td.rdtMonth': {
    marginTop: '14px',
    display: 'inline-block',
  },

  '.rdtPicker thead tr:first-of-type th:hover': {
    background: [`url(${calendar_arrow}) center center no-repeat`],
  },

  'th.rdtSwitch:hover': {
    background: [' transparent !important'],
  },

  'th.rdtSwitch': {
    width: '160px !important',
  },

  '.rdtPicker .dow': { paddingTop: '18px !important' },

  '.rdtPicker td': {
    textAlign: 'center',
    height: 'auto',
    padding: '10px 0px',
  },
  '.rdtPicker td.rdtToday:before': { borderBottom: 'transparent' },
  '.rdtPicker': {
    background: '#fff',
    border: '#D9DBDD solid 1px',
    position: 'absolute',
    top: '-300px',
    left: '70px',

    boxShadow: '0 0 80px 8px rgb(0 0 0 / 16%)',
    width: '365px',
    padding: '24px',
    maxWidth: '368px',
    borderRadius: '8px',

    [MediaQueries.sm]: {
      left: '3px',
      position: 'fixed',
      right: '0',
      top: '12%',
      width: 'auto',
      margin: '5% 5%',
    },

    '.controls': {
      button: {
        background: '#E52500',
        width: '100%',
        borderRadius: '8px',
        color: '#fff',
        height: '56px',
        textTransform: 'uppercase',
        marginTop: '24px',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.875px',
        textAlign: 'center',
      },
    },
    '.rdtDay:hover': {
      background: 'transparent',
    },

    '.rdtDay span:hover': {
      background: '#EEF0F2',
      borderRadius: '50%',
      color: '#393939',
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '.past-date': {
      span: {
        background: '#EEF0F2',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    '.dow': {
      borderBottom: 'none',
      cursor: 'default',
      color: '#747475',
      fontWeight: 400,
      lineHeight: '14px',
      fontSize: '12px',
      paddingTop: '25px',
    },

    td: {
      height: '484px !important',
      verticalAlign: 'middle',
      [MediaQueries.sm]: {
        height: '41px !important',
      },
    },

    'td.rdtActive:hover': {
      background: 'transparent',
      color: '#393939',
      span: {
        borderRadius: '50%',
        background: '#008385',
        width: '32px',
        height: '32px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    'td.rdtActive': {
      background: 'transparent',
      color: '#393939',
      span: {
        borderRadius: '50%',
        background: '#008385',
        width: '32px',
        height: '32px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    'th.rdtPrev': {
      fontSize: '21px',
      verticalAlign: 'middle',
      border: '#D9DBDD solid 1px',
      borderRadius: '4px',
      display: 'block',
      span: {
        width: '100%',
      },
    },

    'th.rdtNext': {
      fontSize: '21px',
      verticalAlign: 'middle',
      borderRadius: '4px',
      display: 'block',
      border: '#D9DBDD solid 1px',
      background: `url(${calendar_arrow})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',

      span: {
        visibility: 'hidden',
      },
    },

    'th.rdtPrev': {
      fontSize: '21px',
      verticalAlign: 'middle',
      borderRadius: '4px',
      display: 'block',
      border: '#D9DBDD solid 1px',
      background: `url(${calendar_arrow})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transform: 'rotate(180deg)',

      span: {
        visibility: 'hidden',
      },
    },

    '.rdtSwitch:hover': {
      background: 'transparent !important',
    },

    'th.rdtSwitch': {
      width: '100px',
      verticalAlign: 'middle',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
    },

    th: {
      span: {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    td: {
      span: {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
});

export const inputcontainer = css({
  fontSize: '16px !important',
});
